import ActionTypes from "../constants";
import GeneralUtils from "../utils/GeneralUtils";


class ConsumptionAnalysisActions {
    getAvailableMeters(ts_start, ts_end) {
        return GeneralUtils.get({
            url: `v2/meters${ts_start && ts_end ? `?from=${ts_start}&to=${ts_end}` : ""}`,
            actionType: ActionTypes.CONSUMPTION_ANALYSIS_METERS_FETCHED,
            failToast: "Unable to fetch meters overview, please try again",
            modifyResponse: (response) => {
                return response.map((meter) => {
                    return {
                        label: `${meter.building.name} - ${meter.meter.name}`,
                        value: meter.meter.id
                    };
                });
            }
        });
    }

    getConsumptionData(meter_id, ts_start, ts_end) {
        return GeneralUtils.get({
            url: `energy/in-out-hours/meter/${meter_id}?from=${ts_start}&to=${ts_end}`,
            actionType: ActionTypes.CONSUMPTION_ANALYSIS_DATA_FETCHED,
        });
    }

}

export default new ConsumptionAnalysisActions();
